import { render } from "./TableData4Setting.vue?vue&type=template&id=f66f4f9a&scoped=true"
import script from "./TableData4Setting.vue?vue&type=script&lang=js"
export * from "./TableData4Setting.vue?vue&type=script&lang=js"

import "./TableData4Setting.vue?vue&type=style&index=0&id=f66f4f9a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f66f4f9a"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/TableData4Setting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f66f4f9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f66f4f9a', __exports__)) {
    api.reload('f66f4f9a', __exports__)
  }
  
  module.hot.accept("./TableData4Setting.vue?vue&type=template&id=f66f4f9a&scoped=true", () => {
    api.rerender('f66f4f9a', render)
  })

}


export default __exports__